import { render, staticRenderFns } from "./ErrorMessage.vue?vue&type=template&id=255b749c&"
import script from "./ErrorMessage.vue?vue&type=script&lang=js&"
export * from "./ErrorMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('255b749c')) {
      api.createRecord('255b749c', component.options)
    } else {
      api.reload('255b749c', component.options)
    }
    module.hot.accept("./ErrorMessage.vue?vue&type=template&id=255b749c&", function () {
      api.rerender('255b749c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2GvZ9dS5za3fH/JS/comp/ErrorMessage.vue"
export default component.exports